<template>
  <div>
    <v-container>
      <v-card>
        <v-card-title>
          <div class="w-100 d-flex flex-row justify-content-between">
            <div>مدیریت حق اشتراک</div>

            <v-spacer></v-spacer>
            <v-btn @click="openForm()" color="primary"> درخواست اشتراک </v-btn>
          </div>
        </v-card-title>
        <v-divider> </v-divider>
        <v-card-text>
          <subscription-list> </subscription-list>
        </v-card-text>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import SubscriptionList from '../components/SubscriptionList.vue';
export default {
  components: {
    SubscriptionList,
  },
  methods: {
    openForm() {
      this.$router.push({ path: `/financial-management/subscription/form` });
    },
  },
};
</script>

<style lang="scss" scoped></style>
